/* eslint-disable jsx-a11y/no-static-element-interactions */
import { FaCheckCircle } from "react-icons/fa";
import ISceltaProfessionistaProps from "components/SceltaProfessionista/ISceltaProfessionistaProps";

import "./SceltaProfessionista.css";

const SceltaProfessionista: React.FC<ISceltaProfessionistaProps> = ({ selected, dsOperatore, idOperatore, OnClick, noPref }) => {
	return (
		<div
			className={`scelta-professionista ${selected ? "scelta-professionista-selected" : ""}  ${noPref && "no-pref"}`}
			onClick={() => OnClick(idOperatore)}
			onKeyDown={(event) => {
				if (event.key === "Enter") {
					OnClick(idOperatore);
				}
			}}
		>
			<FaCheckCircle className={`icon-selected ${selected ? "" : " icon-selected-hidden"}`} />
			<div className="scelta-professionista-spacer"></div>
			<div className="scelta-professionista-content" role="button" tabIndex={0}>
				<div className="scelta-professionista-name">
					<span>{dsOperatore}</span>
				</div>
			</div>
			<div className="scelta-professionista-spacer"></div>
			<div className="scelta-professionista-spacer-fixed"></div>
		</div>
	);
};

export default SceltaProfessionista;
